import { Stack } from "@mui/material";
import useProjectManagementStore from "features/ProjectManagement/hooks/useProjectManagementStore";
import { SWR_OPTION } from "hooks/api/useApiGet";
import useGetProjectBySlug from "hooks/api/useGetProjectBySlug";
import useVidletNavigate from "hooks/navigation/useVidletNavigate";
import useProject from "hooks/useProject";
import { useEffect } from "react";
import { Outlet, useParams } from "react-router";
import colors from "theme/base/colors";
import Header from "./Header";
import LegacyFeatureModal from "./LegacyFeatureModal";
import LegacyImportBanner from "./LegacyImportBanner";
import Sidebar from "./Sidebar";
import HomeButton from "components/HomeButton";

const HEADER_HEIGHT = "3.5rem";
const SIDEBAR_WIDTH = "5.5rem";

function AppLayout() {
  const { navigate } = useVidletNavigate();
  const { slug } = useParams();
  const { project, isLoading } = useGetProjectBySlug(slug, {
    swrOptions: SWR_OPTION.CALL_ONCE,
  });
  const { projectId, name, imported } = useProject();
  const { setProject } = useProjectManagementStore();

  // TODO: This should live elsewhere, not in the layout component
  useEffect(() => {
    if (isLoading || !slug) {
      return;
    }

    if (!project?.id || !project?.name) {
      navigate("/");
      return;
    }

    if (projectId !== project.id) {
      setProject(project);
    }
  }, [project, isLoading, slug, projectId, setProject, navigate]);

  return (
    <Stack sx={{ height: "100vh", width: "100%" }} direction="row">
      <Stack sx={{ width: SIDEBAR_WIDTH }}>
        <HomeButton />
        <Sidebar sx={{ width: SIDEBAR_WIDTH, mt: "1rem" }} />
      </Stack>
      <Stack
        sx={{
          flex: 1,
          minWidth: 0,
          overflow: "hidden",
          width: "100%",
          boxSizing: "border-box",
          justifyContent: "flex-start",
          backgroundColor: imported
            ? colors.background.imported
            : colors.background.default,
        }}
      >
        <LegacyImportBanner />
        <LegacyFeatureModal />
        <Header name={name} sx={{ height: HEADER_HEIGHT }} />
        <Stack
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: "hidden",
            p: "0 1rem",
            alignItems: "center",
            boxSizing: "border-box",
          }}
        >
          <Stack
            sx={{
              flex: 1,
              position: "relative",
              height: "100%",
              width: "100%",
              maxWidth: 1650,
              overflow: "hidden",
            }}
          >
            {projectId && <Outlet />}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default AppLayout;
